import { useMemo, useState } from 'react';
import { format, addDays, lastDayOfMonth as getLastDayOfMonth } from 'date-fns';
import useApiFetch from '@/hooks/useApiFetch';
import candidatesReports from '@/services/candidatesReports';
import { FetchApiIds } from '@/types';
import ChartReadyToHireComponent from './ChartFromReadyToHire.component';

const ChartFromReadyToHire = (): JSX.Element => {
  const [selectedDate, setSelectedDate] = useState(format(new Date(), 'yyyy-MM'));

  const firstDayOfTheMonth = `${selectedDate}-01`;
  const monthPlusADay = addDays(new Date(firstDayOfTheMonth), 1);
  const lastDayOfMonth = getLastDayOfMonth(new Date(monthPlusADay));
  const lastDayFormatted = format(new Date(lastDayOfMonth), 'yyyy-MM-dd');

  const newCandidatesByOwner = useApiFetch([FetchApiIds.READY_TO_HIRE, selectedDate], () => {
    const readyToHireStatuses = [
      'READY_TO_HIRE',
      'OFFER_MADE',
      'OFFER_ACCEPTED',
      'SUBMITTED_TO_CLIENT',
      'REJECTED_BY_CLIENT',
    ];

    const updatedHour = new Date(firstDayOfTheMonth);
    const updatedTo = addDays(new Date(lastDayFormatted), 1);
    updatedHour.setHours(0, 0, 0, 0);
    return candidatesReports.getNewCandidatesByOwners({
      status: readyToHireStatuses.toString() ?? '',
      startDate: updatedHour.toISOString(),
      endDate: updatedTo.toISOString(),
    });
  });

  const formattedResponse = useMemo(() => {
    return newCandidatesByOwner.data?.totalOfCandidatesByOwner ?? [];
  }, [newCandidatesByOwner.data?.totalOfCandidatesByOwner]);

  return (
    <ChartReadyToHireComponent
      isLoading={newCandidatesByOwner.isLoading}
      title="From Ready to Hire"
      tooltipMessage="This chart displays the total number of candidates ready to be hired. It includes all candidates that reached or past the Ready to Hire status and were not rejected after it."
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      data={formattedResponse}
    />
  );
};

export default ChartFromReadyToHire;
